/**
 * InstagramIcon — sanitized from `assets/newSvg/instagram.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function InstagramIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M16,3 C18.7614,3 21,5.23858 21,8 L21,16 C21,18.7614 18.7614,21 16,21 L8,21 C5.23858,21 3,18.7614 3,16 L3,8 C3,5.23858 5.23858,3 8,3 L16,3 Z M12,8 C9.79086,8 8,9.79086 8,12 C8,14.2091 9.79086,16 12,16 C14.2091,16 16,14.2091 16,12 C16,9.79086 14.2091,8 12,8 Z M12,10 C13.1046,10 14,10.8954 14,12 C14,13.1046 13.1046,14 12,14 C10.8954,14 10,13.1046 10,12 C10,10.8954 10.8954,10 12,10 Z M16.5,6.5 C15.9477,6.5 15.5,6.94772 15.5,7.5 C15.5,8.05228 15.9477,8.5 16.5,8.5 C17.0523,8.5 17.5,8.05228 17.5,7.5 C17.5,6.94772 17.0523,6.5 16.5,6.5 Z"
        fill={color}
      />
    </Svg>
  );
}

export default InstagramIcon;
